<template>
  <v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10" class="d-inline">
      <div style="background-color: blue" class="d-inline;">
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig">
        </ckeditor>
      </div>
    </v-col>
    <v-col cols="1" class="text-right ml-n8">
      <v-tooltip top :open-delay="1500" :open-on-hover="true">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            elevation="0"
            tile
            fab
            small
            height="50px"
            width="60"
            class="d-inline mr-2"
            color="indigo lighten-2"
            dark
            v-on="on"
            v-bind="attrs"
            @click="saveComment"
            :disabled="editorData.length < 1"
          >
            <v-icon style="transform: rotate(220deg)">mdi-send</v-icon>
          </v-btn>
        </template>
        <span>Save Comment</span>
      </v-tooltip>

      <!-- <v-btn color="blue darken-1" tile @click="saveComment"></v-btn> -->
    </v-col>
  </v-row>
  <!-- <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Add Comment</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <ckeditor
                :editor="editor"
                v-model="editorData"
                :config="editorConfig"
              ></ckeditor>
            </v-col>
            <v-col cols="12" v-if="errorMessage">
              <h3 class="text-center red--text">{{ errorMessage }}</h3>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        <v-btn color="blue darken-1" text @click="saveComment">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Mention from "@ckeditor/ckeditor5-mention/src/mention";

export default {
  name: "AddCommentModal",
  props: {
    routeId: Number,
    routeType: String,
    dialog: Boolean,
    accessRoute: Number,
    items: Array,
    inSubRoutes: Boolean,
    subRouteIndex: Number,
    parentRouteId: String,
    accessFrom: String,
  },
  data() {
    return {
      message: "",
      initiator_route: parseInt(this.$route.query.init),
      errorMessage: null,
      text: "",
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        placeholder: "Leave a message...",
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Mention,
          MentionCustomization,
        ],
        toolbar: {
          items: [],
        },
        mention: {
          feeds: [
            {
              marker: "@",
              feed: this.getFeedItems,
              itemRenderer: customItemRenderer,
            },
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions([
      "saveNewComment",
      "addRouteCommentCount",
      "addSubrouteCommentCount",
    ]),
    close(result) {
      this.message = "";
      this.errorMessage = null;
      this.$emit("closeDialog", result ? true : false);
      this.editorData = "";
    },
    saveComment() {
      var classesNodeList = document.querySelectorAll(".mention");
      var user_ids = Array.prototype.map.call(
        classesNodeList,
        function (element) {
          return element.dataset.userId;
        }
      );

      user_ids = [...new Set(user_ids)];

      let body = {
        route_id: this.initiator_route,
        type: this.routeType,
        selected_route_id: this.routeId,
        message: this.editorData,
        assigned_route_id: this.accessRoute,
        user_tag_ids: user_ids,
        accessFrom: this.accessFrom,
      };

      this.saveNewComment(body).then((res) => {
        if (res.error) {
          if (res.status == 400) {
            this.errorMessage = res.message;
          } else if (res.status == 500) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Internal Server Error",
            });
          }
        } else {
          if (this.routeType != "subroute") {
            this.addRouteCommentCount(body);
          } else {
            body = Object.assign(body, {
              subroute_index: this.subRouteIndex,
              container: this.parentRouteId,
            });
            this.addSubrouteCommentCount(body);
          }

          Swal.fire({
            icon: "success",
            title: "Comment saved",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.editorData = "";
            this.$emit("loadNewComment", true);
          });
        }
      });
    },
    showUsers() {
      // alert("showing users");
    },
    getFeedItems(queryText) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const itemsToDisplay = this.items.filter(isItemMatching).slice(0, 10);

          resolve(itemsToDisplay);
        }, 100);
      });

      function isItemMatching(item) {
        const searchString = queryText.toLowerCase();

        return (
          item.name.toLowerCase().includes(searchString) ||
          item.id.toLowerCase().includes(searchString)
        );
      }
    },
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.editorConfig.mention.feeds[0].feed = this.getFeedItems;
      }
    },
  },
};

function MentionCustomization(editor) {
  editor.conversion.for("upcast").elementToAttribute({
    view: {
      name: "div",
      key: "data-mention",
      classes: "mention",
      attributes: {
        href: true,
        "data-user-id": true,
      },
    },
    model: {
      key: "mention",
      value: (viewItem) => {
        const mentionAttribute = editor.plugins
          .get("Mention")
          .toMentionAttribute(viewItem, {
            userId: viewItem.getAttribute("data-user-id"),
          });

        return mentionAttribute;
      },
    },
    converterPriority: "high",
  });

  // Downcast the model 'mention' text attribute to a view <a> element.
  editor.conversion.for("downcast").attributeToElement({
    model: "mention",
    view: (modelAttributeValue, { writer }) => {
      // Do not convert empty attributes (lack of value means no mention).
      if (!modelAttributeValue) {
        return;
      }

      return writer.createAttributeElement(
        "div",
        {
          class: "mention",
          "data-mention": modelAttributeValue.id,
          "data-user-id": modelAttributeValue.userId,
        },
        {
          // Make mention attribute to be wrapped by other attribute elements.
          priority: 20,
          // Prevent merging mentions together.
          id: modelAttributeValue.uid,
        }
      );
    },
    converterPriority: "high",
  });
}

function customItemRenderer(item) {
  const itemElement = document.createElement("span");

  itemElement.classList.add("custom-item");
  itemElement.id = `mention-list-item-id-${item.userId}`;
  itemElement.textContent = `${item.name} `;

  const usernameElement = document.createElement("span");

  usernameElement.classList.add("custom-item-username");
  // usernameElement.textContent = item.id;

  itemElement.appendChild(usernameElement);

  return itemElement;
}
</script>

<style>
.demo {
  margin: 24px 0;
}

.input {
  border: #ccc 1px solid;
  border-radius: 6px;
  resize: vertical;
  min-height: 42px;
  padding: 12px;
  box-sizing: border-box;
  line-height: 1.2em;
  font-size: inherit;
}

.issue {
  padding: 4px 6px;
  border-radius: 4px;
  cursor: pointer;
}

p > .mention {
  display: inline;
}

.mention-selected .issue {
  background: rgb(139, 212, 255);
}

.issue .number {
  font-family: monospace;
}

.dim {
  color: #666;
}

.preview {
  font-family: monospace;
  white-space: pre-wrap;
  margin-top: 12px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 6px;
}
</style>
